const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Temple extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Temple.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.cultureProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount(),
                        });
                        playerState.happyFaceCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount() * multiplier,
                        });
                    }
            }
        )
        // Happy faces per temple (worker), e.g. for Michelangelo
        this.happyFaces = multiplier;
    }
    static GetType = () => TechnologyTypes.Urban.Temple;
}

class Religion extends Temple {
    constructor(){
        super(Religion.GetAge(), Religion.GetName(), 0, 3, 1)
    }

    static GetInstance = () => new Religion();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Urban.Religion;
}

class Theology extends Temple {
    constructor(){
        super(Theology.GetAge(), Theology.GetName(), 2, 5, 2)
    }

    static GetInstance = () => new Theology();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Urban.Theology;
}

class OrganizedReligion extends Temple {
    constructor(){
        super(OrganizedReligion.GetAge(), OrganizedReligion.GetName(), 4, 7, 3)
    }

    static GetInstance = () => new OrganizedReligion();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Urban.OrganizedReligion;
}

module.exports = {
    Religion,
    Theology,
    OrganizedReligion
}